import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

/**Local files */
import { orders } from '../utils/index';

@Injectable()
export class CommonQueryService {
  ordersValues = orders;

  public allOrderDetails: any;
  public GET_FIRST_ORDER_DETAILS: any;
  public GET_NEXT_ORDER_DETAILS: any;
  public UPDATE_ORDER_DETAILS: any;
  public GET_ORDER_BY_ID: any;

  constructor(public apollo: Apollo) {
    /*get all orders based on address*/
    this.allOrderDetails = gql`
      query GetOrders {
        allInspectionReportsSrcs(orderBy: ORDER_ID_DESC) {
          edges {
            node {
              id
              orderId
              insReportId
              reportReviewDetailsByInsReportId(first: 1) {
                edges {
                  node {
                    orderId
                    reviewId
                  }
                }
              }
              scheduleRequestByScheduleRequestId {
                id
                createdAt
                acceptStatus
                statusChangeAt
                scheduleRequestDate
                userByAcceptedBy {
                  firstName
                  lastName
                  email
                }
              }
              solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                nodes{  
                  roleid           
                  roleByRoleid{
                    roleId
                    roleName
                  } 
                  userByUserid {
                    userId
                    firstName
                  }
                  createdat
                }
              }

              reportSolutionMastersByInsReportId(first: 1) {
                nodes {
                  createdAt
                  id
                }
              }
            }
          }
        }
        # allOcrDumps(orderBy:ORDER_ID_DESC) {

        #     nodes {
        #         orderId
        #     }

        #  }
      }
    `;

    /*get all orders */
    this.GET_FIRST_ORDER_DETAILS = gql`
    query GetOrders($first:Int!) {
      allOrders(first:$first,orderBy: ID_DESC,condition:{archive:null}){
        nodes{
           id
           nodeId
           archive
           orderContent
            inspectionReportsSrcByOrderId {
                   id
                  orderId
                  insReportId
                  reportReviewDetailsByInsReportId(first: 1) {
                    edges {
                      node {
                        orderId
                        reviewId
                      }
                    }
                  }
                  scheduleRequestByScheduleRequestId {
                    id
                    createdAt
                    acceptStatus
                    statusId
                    statusChangeAt
                    scheduleRequestDate
                    nodeId
                    userByAcceptedBy {
                      firstName
                      lastName
                      email
                    }
                  }
                  solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                    nodes{  
                      roleid           
                      roleByRoleid{
                        roleId
                        roleName
                      } 
                      userByUserid {
                        userId
                        firstName
                        lastName
                      }
                      createdat
                    }
                  }
    
                  reportSolutionMastersByInsReportId(first: 1) {
                    nodes {
                      createdAt
                      id
                    }
                  }
              
                 
              
            }     
           
              orderStatusesByOrderId(orderBy:ID_DESC,first:1){
                    nodes {
                      orderId
                      statusId
                      statusByStatusId {
                        statusId
                        statusName
                      }
				      	}
				      }
        }
         pageInfo
        {
            startCursor
            endCursor
            hasNextPage
        }
         totalCount
      }
     
    }
    
    `;



    /*get all orders */
    this.GET_NEXT_ORDER_DETAILS = gql`
    query GetOrder($first:Int!,$cursor:Cursor!) {
    allOrders(after: $cursor,first:$first,orderBy: ID_DESC,condition:{archive:null}){
        nodes{
          id
          nodeId
          archive
          orderContent
            inspectionReportsSrcByOrderId {
                  id
                  orderId
                  insReportId
                  reportReviewDetailsByInsReportId(first: 1) {
                    edges {
                      node {
                        orderId
                        reviewId
                      }
                    }
                  }
                  scheduleRequestByScheduleRequestId {
                    id
                    createdAt
                    acceptStatus
                    statusId
                    statusChangeAt
                    scheduleRequestDate
                    userByAcceptedBy {
                      firstName
                      lastName
                      email
                    }
                  }
                  solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                    nodes{  
                      roleid           
                      roleByRoleid{
                        roleId
                        roleName
                      } 
                      userByUserid {
                        userId
                        firstName
                        lastName
                      }
                      createdat
                    }
                  }
    
                  reportSolutionMastersByInsReportId(first: 1) {
                    nodes {
                      createdAt
                      id
                    }
                  }
                
              
            }     
          
            orderStatusesByOrderId(orderBy:ID_DESC,first:1){
              nodes {
                orderId
                statusId
                statusByStatusId {
                  statusId
                  statusName
                }
              }
            }
        }
        pageInfo
        {
            startCursor
            endCursor
            hasNextPage
        }
        totalCount
      }
    
    }
    `;


    //Update KPI report  detail
    this.UPDATE_ORDER_DETAILS = gql` 
    mutation updateOrder($input:UpdateOrderInput!) {

      updateOrder(input:$input) {
            order{
                  id
                  archive
                  editedAt
                  editedBy
                }
            }
        }
    `;

    this.GET_ORDER_BY_ID = gql`
    query GetOrders($input:Int!) {
      allOrders(condition:{id:$input}) {
         nodes{
          id
          nodeId
          archive
          orderContent
          orderStatusesByOrderId(orderBy:ID_DESC,first:1){
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
      }
     

  } `;





  }

  /*Get allocated & accepted orders*/
  GET_ORDERS(): any {
    return this.apollo.watchQuery({
      query: this.allOrderDetails,
      fetchPolicy: 'network-only',
    });
  }







  /*Get allocated & accepted orders*/
  GET_ALL_ORDERS(from, cursor): any {
    return this.apollo.watchQuery({
      query: (cursor == '') ? this.GET_FIRST_ORDER_DETAILS : this.GET_NEXT_ORDER_DETAILS,
      variables:
      {
        "first": from,
        "cursor": cursor
      },
      fetchPolicy: 'network-only',
    });
  }



  UPDATE_ORDER(nodeId, archive) {

    let status = archive;
    console.log('archive $$$$$$$$', archive);
    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_DETAILS,
      variables: {
        "input": {
          "nodeId": nodeId,
          "orderPatch": {
            "archive": status
          }
        }
      },
      fetchPolicy: 'no-cache'
    })
  }

  EDIT_ORDER(nodeId, userId, orderDetails) {
    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_DETAILS,
      variables: {
        "input": {
          "nodeId": nodeId,
          "orderPatch": {
            "editedAt": new Date(),
            "editedBy": userId,
            "orderContent": orderDetails
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }




  /*Get allocated & accepted orders*/
  FETCH_ORDER_BY_ID(id): any {
    return this.apollo.watchQuery({
      query: this.GET_ORDER_BY_ID,
      variables: {

        "input": Number.parseInt(id)

      },
      fetchPolicy: 'network-only',
    });
  }









}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/commonQuery.ts